import { PublicInstitutionsListComponent } from './public-instituitions/public-institutions-list/public-institutions-list.component';
import { NgModule } from '@angular/core';
import { RouterModule } from "@angular/router";
import {LocationStrategy, PathLocationStrategy} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerModule } from 'ngx-spinner';
import {FileUploadModule} from 'ng2-file-upload';
import {PdfViewerModule} from   'ng2-pdf-viewer';
//import { FileSelectDirective } from 'ng2-file-upload';
import { HttpClientModule }    from '@angular/common/http';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ChartsModule } from 'ng2-charts';

import { ROUTES } from "./app.routes";
// import alert service and component
import { AlertComponent } from './alert/alert.component';
import { AlertService } from './shared/services/alert.service';
import { AppComponent } from './app.component';

// Shared module
import { SharedModule } from './shared/shared.module';
import { DisableControlDirective } from './shared/directives/disable-control.directive'; // Datepicker https://valor-software.com/ngx-bootstrap/#/modals

// App views
import { WelcomeComponent } from "./views/welcome/welcome.component";
import { LoginModule } from "./views/login/login.module";

// App modules/components
import { LayoutsModule } from "./components/common/layouts/layouts.module";
import { UserListComponent } from './user-list/user-list.component';
import { CreateApplicationComponent } from './application/create/create-application.component';
import { DataTablesModule } from "angular-datatables";
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';

import { ListApplicationsComponent } from './application/list/list-applications.component';
import { ApplicationDetailComponent } from './application/application-detail/application-detail.component';
import { FilePreviewComponent } from './application/file-preview/file-preview.component';
import { GenerateCertificateModal } from './application/generate-certificate-modal/generate-certificate-modal.component';
import { FacilityListComponent } from './facility/facility-list/facility-list.component';
import { ProfessionalsComponent } from './application/professionals/professionals.component';
import { ModuleConfigComponent } from './settings/module-config/module-config.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ResetPasswordComponent } from './views/reset-password/reset-password.component';
import { ApplicationChecklistComponent } from './application/application-checklist/application-checklist.component';
import { ButtonsModule} from 'ngx-bootstrap/buttons';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DirectivesModule } from './directives/directives.module';
import { RenewApplicationComponent } from './application/renew-application/renew-application.component';
import { SpecificProductConfigComponent } from './settings/specific-product-config/specific-product-config.component';
import { FacilityCategorizeComponent } from './facility/facility-categorize/facility-categorize.component';
import {NameFilterPipe} from './shared/pipes/NameFilterPipe';
import { SystemSettingsComponent } from './settings/system-settings/system-settings.component';
import { ApplicationDeclarationLetterComponent } from './application/application-declaration-letter/application-declaration-letter.component';
import { LegacyDataUserAssociationComponent } from './settings/legacy-data-user-association/legacy-data-user-association.component';
import { ChangeCategoryHistoryComponent } from './facility/facility-categorize/change-category-history/change-category-history.component';
import { ChangeApplicationComponent } from './application/change-application/change-application.component';
import { EditApplicationComponent } from './application/edit-application/edit-application.component';
import { ChangePasswordComponent } from './views/change-password/change-password.component';
import { DashboardComponent } from './application/dashboard/dashboard/dashboard.component';
import { SortByPipe } from './shared/pipes/SortByPipe';
import { ReportListConfigComponent } from "./settings/report-config/report-list/report-list-config.component";
import { ReportDetailConfigComponent } from './settings/report-config/report-detail-config/report-detail-config.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ReportRoleConfigComponent } from './settings/report-role-config/report-role-config.component';
import { ReportsComponent } from './report/reports/reports.component';
import { ReportDetailComponent } from './report/report-detail/report-detail.component';
import { EditAccountComponent } from './edit-account/edit-account.component';
import { ReplaceApplicationComponent } from './application/replace-application/replace-application.component';
import { ReturnApplicationComponent } from './application/return-application/return-application.component';
import { WarehouseAdditionApplicationComponent } from './application/warehouse-addition-application/warehouse-addition-application.component';
import { ProfessionalConfigComponent } from './settings/professional-config/professional-config.component';
import { PublicInstitutionsService } from './services/public-institutions.service';
import { PublicInstitutionsDetailComponent } from './public-instituitions/public-institutions-detail/public-institutions-detail.component';
import { InspectionModule } from './inspection/inspection.module';
import { BasicModalModule } from './application/basic-modal/basic-modal.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {ErisLoginInterceptor} from './services/sso/eris-login.interceptor';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ManageTinComponent } from './facility/manage-tin/manage-tin.component';
import { AgmCoreModule } from '@agm/core';
import { ProductionLineConfigComponent } from './settings/production-line-config/production-line-config.component';
import { ErisFormElementsModule } from 'eris-forms';


@NgModule({
  declarations: [
    AppComponent,
    UserListComponent,
    CreateApplicationComponent,
    AlertComponent,
    //FileSelectDirective
    ListApplicationsComponent,
    ApplicationDetailComponent,
    FilePreviewComponent,
    GenerateCertificateModal,
    DisableControlDirective,
    FacilityListComponent,
    ProfessionalsComponent,
    ModuleConfigComponent,
    ResetPasswordComponent,
    ApplicationChecklistComponent,
    RenewApplicationComponent,
    SpecificProductConfigComponent,
    FacilityCategorizeComponent,
    NameFilterPipe,
    SortByPipe,
    SystemSettingsComponent,
    ApplicationDeclarationLetterComponent,
    LegacyDataUserAssociationComponent,
    ChangeCategoryHistoryComponent,
    ChangeApplicationComponent,
    EditApplicationComponent,
    ChangePasswordComponent,
    DashboardComponent,
    ReportListConfigComponent,
    ReportDetailConfigComponent,
    ReportRoleConfigComponent,
    ReportsComponent,
    ReportDetailComponent,
    EditAccountComponent,
    ReplaceApplicationComponent,
    ReturnApplicationComponent,
    WarehouseAdditionApplicationComponent,
    ProfessionalConfigComponent,
    PublicInstitutionsListComponent,
    PublicInstitutionsDetailComponent,
    WelcomeComponent,
    ManageTinComponent,
    ProductionLineConfigComponent
],

imports: [
	// Angular modules
    HttpClientModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    FileUploadModule,
    BrowserAnimationsModule,
    // Views
    LoginModule,
    PdfViewerModule,
    NgxSpinnerModule,
    ButtonsModule,
    DirectivesModule,
    // Modules
    SharedModule,
    LayoutsModule,
    ChartsModule,
    DataTablesModule,
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    RouterModule.forRoot(ROUTES, { relativeLinkResolution: 'legacy' }),
    InspectionModule,
    BasicModalModule,
    AccordionModule.forRoot(),
    ErisFormElementsModule.forRoot(),
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#64695c",
      innerStrokeColor: "#C7E596",
      animationDuration: 300
      }),
    PopoverModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCxddzDbVG435QzZyeamkr9oneWU-GMAhY'
    })
  ],
  entryComponents: [FilePreviewComponent,ChangePasswordComponent,EditAccountComponent],
  providers: [{provide: LocationStrategy, useClass: PathLocationStrategy},AlertService, PublicInstitutionsService, BsModalRef,

  { provide: HTTP_INTERCEPTORS, useClass: ErisLoginInterceptor, multi: true },

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
